// extracted by mini-css-extract-plugin
module.exports = {"root":"Login_root__cxDvD","logo":"Login_logo__3R5vb","form":"Login_form__2mkKy","inputs":"Login_inputs__1J0pU","buttons":"Login_buttons__a3Pxe"};